import { Epic, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { addErrorNotice, catchWithAuthErrors } from 'Data/Helpers/rxjsHelpers';
import { callApiGetAgsExport, callApiReissueAgsExport } from './apiCalls';
import { actions } from './slice';

export const init: Epic = (action$) =>
  action$.pipe(
    ofType(actions.init.toString()),
    mergeMap(({ payload: agsExportId }) =>
      callApiGetAgsExport(agsExportId).pipe(
        mergeMap((agsExport) => of(actions.initResolve(agsExport))),
        catchWithAuthErrors((err: any) =>
          of(actions.initReject(), addErrorNotice('Failed to initialise ags export.', err))
        )
      )
    )
  );

export const reissue: Epic = (action$) =>
  action$.pipe(
    ofType(actions.reissueExport.toString()),
    mergeMap(({ payload: agsExportId }) =>
      callApiReissueAgsExport(agsExportId).pipe(
        mergeMap((newRevision) => of(actions.reissueExportResolve(newRevision))),
        catchWithAuthErrors((err: any) =>
          of(actions.reissueExportReject(), addErrorNotice('Failed to reissue ags export.', err))
        )
      )
    )
  );
